module.exports = __webpack_public_path__ + "static/media/pavilions.7626e173.svg";